import { FormControl, FormGroup } from '@angular/forms';
import { isDefined } from 'ionic-angular/util/util';
import { Subject } from 'rxjs/Subject';
import { BaseComponent } from '../../../core/components/base.component';
import { Control } from '../../../vas/business-objects/control/control.model';
import { FormInlined } from '../../../vas/business-objects/form/form.model';
import { Group } from '../../../vas/business-objects/group/group.model';
import { IControlConfigComponentArgs } from '../../../vas/controls/control-config-component-args.interface';

export abstract class ControlConfigComponent extends BaseComponent implements IControlConfigComponentArgs {
    formGroup: FormGroup;
    data: Control;
    form: FormInlined;
    formGroups: Array<Group>;
    ngUnsubscribe: Subject<void> = new Subject<void>();

    getConfigValue(key, defaultValue?): any {
        if (!isDefined(this.data.config[key])) {
            return defaultValue;
        }
        return this.data.config[key];
    }

    getFormControl(key: string): FormControl {

        const formControl = this.formGroup.get(key);

        if (!formControl) {
            console.warn("form control for '%s' not found. returning empty control", key);
            return new FormControl();
        }

        return formControl as FormControl;
    }
}



// WEBPACK FOOTER //
// ./src/app/lib/components/edit-control-config.component.ts